import { useEffect } from "react";
import { toast } from "sonner";

/**
 * Fires a warm one-time toast the first time the app is opened in
 * standalone / PWA mode (i.e. after the user installed to home screen).
 *
 * Persistence: a single flag in localStorage — no duplicate toasts on
 * subsequent standalone opens.
 */
const FLAG = "ep_pwa_welcome_seen";

function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export default function PWAWelcome() {
  useEffect(() => {
    if (!isStandalone()) return;
    try {
      if (localStorage.getItem(FLAG)) return;
      localStorage.setItem(FLAG, String(Date.now()));
    } catch {
      /* ignore quota */
    }
    // Wait 1.2s so the toast doesn't collide with the app's first paint
    const t = setTimeout(() => {
      toast.success("Thanks for installing 🌙", {
        description:
          "Earth Pulse is now on your home screen. Open it any time — we'll be here.",
        duration: 6500,
        // sonner colour token override via data attributes handled by the toast provider
      });
    }, 1200);
    return () => clearTimeout(t);
  }, []);
  return null;
}
